<template>
    <div class="grid">
        <div class="col-6">
            <FormField :labelName="$t('sto_no')" fieldName="Document_No" v-model="stomodel" fieldClass="col-6" labelClass="col-4" v-if="!isCreate">
                <InputText :placeholder="$t('sto_no')" name="Document_No" v-model="stomodel.Document_No" type="text" v-if="stomodel" :disabled="true" />
            </FormField>

            <FormField :labelName="$t('doc_date')" fieldName="Document_Date" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <DatePicker v-model="stomodel.Document_Date" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="stomodel" :disabled="mode != $FORM_MODE_CREATE && !isWaiting"/>    
            </FormField>

            <FormField :labelName="$t('company')" fieldName="Company_Code" v-model="stomodel" fieldClass="col-6" labelClass="col-4" required>
                <CustomSelect class="p-inputtext-sm" v-model="stomodel.Company_Code" :filter="true" :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{ }"  :disabled="mode != $FORM_MODE_CREATE && !isWaiting"  />
            </FormField>

            <FormField :labelName="$t('purchase_org')" fieldName="Purchase_Organization" v-model="stomodel" fieldClass="col-6" labelClass="col-4" required>
                <CustomSelect class="p-inputtext-sm" v-model="stomodel.Purchase_Organization" :filter="true" :url="this.$API_URL + 'list/purchase_organization'" :minLength="0" :params="{ check_auth: $TRANSACTION_TYPE.STO }"  :disabled="!canEditHeader"  />
            </FormField>

            <FormField :labelName="$t('purchase_group')" fieldName="Purchase_Group" v-model="stomodel" fieldClass="col-6" labelClass="col-4" required>
                <CustomSelect class="p-inputtext-sm" v-model="stomodel.Purchase_Group" :filter="true" :url="this.$API_URL + 'list/purchase_group'" :minLength="0" :params="{ }"  :disabled="!canEditHeader"   />
            </FormField>

            <div v-if="stomodel && stomodel.Per_Value == 'Y'">
                <FormField :labelName="$t('number_trip')" fieldName="Num_Trip" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <div class="p-inputgroup">
                        <InputNumber name="Num_Trip" mode="decimal" :optionalDecimal="true" disabled v-model="stomodel.Num_Trip" v-if="stomodel"/>
                        <span class="p-inputgroup-addon" v-if="stomodel" style="padding-left:2rem; padding-right:2rem;">{{stomodel.Num_Trip_UOM}}</span>
                    </div>
                </FormField>
            </div>
            

            <FormField :labelName="$t('tolerance_expeditor')" fieldName="Tolerance_Expeditor" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <InputNumber class="p-inputtext-sm w-5rem" v-model="stomodel.Tolerance_Expeditor" mode="decimal" :optionalDecimal="true" @blur="onChangeToleranceExpeditor" :disabled="!canEditHeader"/>
            </FormField>

            <FormField :labelName="$t('sto_type')" fieldName="STO_Type" v-model="stomodel" fieldClass="col-6" labelClass="col-4" required >
                <CustomSelect class="p-inputtext-sm" v-model="stomodel.STO_Type" :filter="true" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.STO_TYPE }"  :disabled="mode != $FORM_MODE_CREATE && !isWaiting"  />
            </FormField>

            <FormField :labelName="$t('valid_from')" fieldName="Valid_From" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <DatePicker :placeholder="$t('valid_from')" v-model="stomodel.Valid_From" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="stomodel" disabled />    
            </FormField>

            <FormField :labelName="$t('valid_to')" fieldName="Valid_To" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <DatePicker :placeholder="$t('valid_to')" v-model="stomodel.Valid_To" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="stomodel" disabled />    
            </FormField>

            <FormField :labelName="$t('without_price')" fieldName="Without_Price" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <YNCheckbox v-model="stomodel.Without_Price" v-if="stomodel" :disabled="mustWithoutPrice || !canEditHeader" :binary="true" @change="onClickWithoutPrice"/>
            </FormField>
        </div>
        <div class="col-6">
            <FormField :labelName="$t('vat_regulation')" fieldName="VAT_Regulation" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <CustomSelect :placeholder="$t('vat_regulation')" class="p-inputtext-sm" v-model="stomodel.VAT_Regulation" :filter="true" :url="this.$API_URL + 'list/vat_regulation'" :minLength="0" :params="{ }"  :disabled="!canEditHeader" />
            </FormField>

            <FormField :labelName="$t('with_contract')" fieldName="filter_loading" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <YNCheckbox v-model="stomodel.With_Contract" v-if="stomodel" :disabled="!canEditHeader" :binary="true"/>
            </FormField>

            <FormField :labelName="$t('contract_no')" fieldName="Contract_No" v-model="stomodel" fieldClass="col-6" labelClass="col-4">
                <InputText :placeholder="$t('contract_no')" name="Contract_No" v-model="stomodel.Contract_No" type="text" v-if="stomodel" :disabled="!canEditHeader || stomodel.With_Contract != 'Y'" />
            </FormField>

            <FormField :labelName="$t('contract_date')" fieldName="Contract_Date" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <DatePicker v-model="stomodel.Contract_Date" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="stomodel" :disabled="!canEditHeader || stomodel.With_Contract != 'Y'"/>    
            </FormField>

            <FormField :labelName="$t('pic')" fieldName="PIC" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <CustomSelect :placeholder="$t('pic')" class="p-inputtext-sm" v-model="stomodel.PIC" :filter="true" :url="this.$API_URL + 'list/pic_contract'" :minLength="0" :params="{ }"  :disabled="!canEditHeader || stomodel.With_Contract != 'Y'" @change="onChangePIC" />
            </FormField>

            <FormField :labelName="$t('pic_location')" fieldName="PIC_Location" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <InputText :placeholder="$t('pic_location')" name="PIC_Location" v-model="stomodel.PIC_Location" type="text" v-if="stomodel" :disabled="true" />
            </FormField>

            <FormField :labelName="$t('pib_no')" fieldName="PIB_No" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <InputText :placeholder="$t('pib_no')" name="PIB_No" v-model="stomodel.PIB_No" type="text" v-if="stomodel" :disabled="!canEditHeader" />
            </FormField>

            <FormField :labelName="$t('fba_no')" fieldName="FBA_No" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                <InputText :placeholder="$t('fba_no')" name="FBA_No" v-model="stomodel.FBA_No" type="text" v-if="stomodel" :disabled="!canEditHeader || !canInputFBA" />
            </FormField>

            <FormField :labelName="$t('change_reason')" fieldName="Change_Reason" v-model="stomodel" fieldClass="col-6" labelClass="col-4" v-if="mode != $FORM_MODE_CREATE">
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Change_Reason" :disabled="mode == $FORM_MODE_VIEW" />
                </FormField>

        </div>
    </div>

    <Fieldset :legend="$t('communication')" :toggleable="true" :collapsed="true">
        <div class="grid">
            <div class="col-6">
                <FormField :labelName="$t('salesperson')" fieldName="Salesperson" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <InputText :placeholder="$t('salesperson')" name="Salesperson" v-model="stomodel.Salesperson" type="text" v-if="stomodel" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('telephone')" fieldName="Telephone" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <InputText :placeholder="$t('telephone')" name="Telephone" v-model="stomodel.Telephone" type="text" v-if="stomodel" :disabled="!canEditHeader" />
                </FormField>

                <!-- <FormField :labelName="$t('language')" fieldName="Language" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <InputText :placeholder="$t('language')" name="Language" v-model="stomodel.Language" type="text" v-if="stomodel" :disabled="!canEdit" />
                </FormField> -->
            </div>
            <div class="col-6">
                <FormField :labelName="$t('your_reference')" fieldName="Your_Reference" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <InputText :placeholder="$t('your_reference')" name="Your_Reference" v-model="stomodel.Your_Reference" type="text" v-if="stomodel" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('our_reference')" fieldName="Our_Reference" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <InputText :placeholder="$t('our_reference')" name="Our_Reference" v-model="stomodel.Our_Reference" type="text" v-if="stomodel" :disabled="!canEditHeader" />
                </FormField>
            </div>
        </div>
    </Fieldset>

    <Fieldset :legend="$t('header_text')" :toggleable="true" class="mt-2" :collapsed="true">
        <div class="grid">
            <div class="col-6">
                <FormField :labelName="$t('header_text')" fieldName="Header_Text" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Header_Text" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('header_note')" fieldName="Header_Note" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Header_Note" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('pricing_types')" fieldName="Pricing_Types" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Pricing_Types" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('deadlines')" fieldName="Deadlines" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Deadlines" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('terms_of_delivery')" fieldName="Terms_of_Delivery" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Terms_of_Delivery" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('shipping_instructions')" fieldName="Shipping_Instructions" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Shipping_Instructions" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('payment_method')" fieldName="Payment_Method" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Payment_Method" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('warranties')" fieldName="Warranties" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Warranties" :disabled="!canEditHeader" />
                </FormField>
                
                <FormField :labelName="$t('penalty')" fieldName="Penalty" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Penalty" :disabled="!canEditHeader" />
                </FormField>
                
                <FormField :labelName="$t('guarantees')" fieldName="Guarranties" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Guarranties" :disabled="!canEditHeader" />
                </FormField>

                <!-- <FormField :labelName="$t('contract_riders')" fieldName="Contract_Riders" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Contract_Riders" :disabled="!canEdit" />
                </FormField> -->

                <FormField :labelName="$t('commodity')" fieldName="Commodity" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Commodity" :disabled="!canEditHeader" />
                </FormField>

                 <FormField :labelName="$t('other_contractual')" fieldName="Other_Contractual" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Other_Contractual" :disabled="!canEditHeader" />
                </FormField>

                
            </div>
            <div class="col-6">

                <FormField :labelName="$t('loading_destination')" fieldName="Loading_Destination" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Loading_Destination" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('vendor_memo')" fieldName="Vendor_Memo" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Vendor_Memo" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('transport_mode')" fieldName="Transport_Mode" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Transport_Mode" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('cost_center')" fieldName="Cost_Center" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Cost_Center" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('laytime')" fieldName="Laytime" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Laytime" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('demurrage')" fieldName="Demurrage" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Demurrage" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('approval_remarks')" fieldName="Approval_Remarks" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Approval_Remarks" :disabled="!canEditHeader" />
                </FormField>
                
                <FormField :labelName="$t('transfer_to')" fieldName="Transfer_To" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Transfer_To" :disabled="!canEditHeader" />
                </FormField>
                
                <FormField :labelName="$t('doc_reference')" fieldName="Doc_Reference" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Doc_Reference" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('contract_person')" fieldName="Contract_Person" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Contract_Person" :disabled="!canEditHeader" />
                </FormField>
                
                <FormField :labelName="$t('address')" fieldName="Address" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Address" :disabled="!canEditHeader" />
                </FormField>

                <FormField :labelName="$t('po_change_revision')" fieldName="PO_Change_Revision" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.PO_Change_Revision" :disabled="!canEditHeader" />
                </FormField>

                 <FormField :labelName="$t('tolerance')" fieldName="Tolerance" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Tolerance" :disabled="!canEditHeader" />
                </FormField>

                 <FormField :labelName="$t('plate_no')" fieldName="Plate_No" v-model="stomodel" fieldClass="col-6" labelClass="col-4" >
                    <Textarea :autoResize="true" rows="3"  v-model="stomodel.Plate_No" :disabled="!canEditHeader" />
                </FormField>
            </div>
        </div>
    </Fieldset>

    <Fieldset :legend="$t('condition_type')" :toggleable="true" class="mt-2">
        <DataTable 
            v-if="stomodel"
            class="p-datatable-sm editable-cells-table"
            :value="stomodel.Conditions" 
            responsiveLayout="scroll" 
            :rowClass="hideRow"
            >
            <Column :exportable="false" bodyStyle="width:30px;display:table-cell">
                <template #header="">
                    <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addCondition"  :disabled="!canEditHeader"/>
                </template>
                <template #body="slotProps">
                    <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteCondition(slotProps)"  :disabled="slotProps.data.Condition_Category == $CONDITION_CATEGORY.FREIGHT || !canEditHeader" />
                </template>
            </Column>
            <Column field="Condition_Type" :header="$t('condition_type')" headerStyle="width:20vw" bodyStyle="width:20vw;display:table-cell"> 
                <template #body="slotProps">
                    <CustomSelect class="p-inputtext-sm" v-model="slotProps.data.Condition_Type" :filter="true" :url="this.$API_URL + 'list/condition_type'" :minLength="0" :params="{ category: slotProps.data.Condition_Category, per_value:  slotProps.data.Condition_Category == $CONDITION_CATEGORY.FREIGHT ? 'Y' : '' }" :disabled="!canEditHeader" />
                </template>
            </Column>
             <Column field="Amount" :header="$t('amount')" headerStyle="width:10vw" bodyStyle="width:10vw;display:table-cell">
                <template #body="slotProps" >
                    <InputNumber  name="Amount" mode="decimal" :optionalDecimal="true" v-model="slotProps.data.Amount" :disabled="slotProps.data.Condition_Category == $CONDITION_CATEGORY.FREIGHT || !canEditHeader"/>
                </template>
            </Column>
            <Column field="Ccy" :header="$t('ccy')" headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
                <template #body="slotProps">
                    <InputText name="Ccy" type="text" disabled v-model="slotProps.data.Ccy" />
                </template>
            </Column>
            <!-- <Column field="Per" :header="$t('per')" headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
                <template #body="slotProps">
                    <InputText name="Per" type="text" v-model="slotProps.data.Per" :disabled="slotProps.data.Condition_Category == $CONDITION_CATEGORY.FREIGHT || !canEdit" />
                </template>
            </Column>
            <Column field="UOM" :header="$t('uom')" headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
                <template #body="slotProps">
                    <InputText name="UOM" type="text" v-model="slotProps.data.UOM" :disabled="slotProps.data.Condition_Category == $CONDITION_CATEGORY.FREIGHT || !canEdit"/>
                </template>
            </Column> -->
            <Column field="Transporter_Code" :header="$t('transporter')" headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
                <template #body="slotProps">
                    <InputText name="Transporter_Code" type="text" disabled v-model="slotProps.data.Transporter_Code" />
                    <!-- <CustomSelect class="p-inputtext-sm" v-model="slotProps.data.Transporter_Code" :filter="true" :url="this.$API_URL + 'list/transporter_all'" :minLength="0" :params="{ }" /> -->
                </template>
            </Column>
        </DataTable>
    </Fieldset>

    <div v-if="mode == $FORM_MODE_DELETE">
        <Divider />

        <div class="grid mb-1">
            <div class="col-2">
                <Button icon="pi pi-trash" label="Delete Item" class="p-button mr-2 p-button-danger" @click="simulateDeleteItem" /> 
            </div>
        </div>

        <DataTable
            v-if="stomodel"
            :value="stomodel.OrderDetails"
            class="p-datatable-sm editable-cells-table"
            responsiveLayout="scroll">
            <Column :exportable="false">
                <template #body="slotProps">
                    <Checkbox v-model="slotProps.data.will_delete" :binary="true"  :disabled="slotProps.data.Is_Deleted"/>
                </template>
            </Column>
            <Column field="" header="No" style="width:10%">
                <template #body="slotProps">
                    {{slotProps.index + 1}}
                </template>
            </Column>
            <Column field="SAP_No" :header="$t('sap_no')">
            </Column>
            <Column field="SAP_Item_No" :header="$t('sap_item_no')">
            </Column>
            <Column field="Order_No" :header="$t('order_no')">
            </Column>
            <Column field="Order_Item_No" :header="$t('order_item_no')">
            </Column>
            <Column field="Shipment_No" :header="$t('shipment_no')">
            </Column>
            <Column field="Shipment_Item_No" :header="$t('shipment_item_no')">
            </Column>
            <Column field="material" :header="$t('material_description')">
            </Column>
            <Column field="sto_no" :header="$t('sto_no')">
            </Column>
            <Column field="sto_item_no" :header="$t('sto_item_no')">
            </Column>
            <Column field="spo_no" :header="$t('spo_no')">
            </Column>
            <Column field="spo_item_no" :header="$t('spo_item_no')">
            </Column>
        </DataTable>

    </div>

    <Divider />

    <DataTable 
        v-if="stomodel"
        :value="stomodel.Details"
        class="p-datatable-sm editable-cells-table"
        responsiveLayout="scroll" 
        v-model:expandedRows="expandedRows"
        @rowExpand="onRowExpand"
        @rowCollapse="onRowCollapse"
        :rowClass="deleteRow"
        >
        <Column :exportable="false"  :expander="true">
            <template #body="slotProps">
                <Button icon="pi pi-copy" class="p-button-primary ml-2 mr-4 p-button-sm" @click="copyDetail(slotProps)" :disabled="!canEdit(slotProps.data)" />
            </template>
        </Column>
        <Column field="Item_No" :header="$t('item_no')"> 
            <template #body="slotProps">
                <InputText name="Item_No" type="text" disabled v-model="slotProps.data.Item_No" style="width:5vw" />
            </template>
        </Column>
         <Column field="material_name" :header="$t('material')">
            <template #body="slotProps">
                {{slotProps.data.Material_Description}}
            </template>
        </Column>
        <Column field="Qty" :header="$t('qty')">
            <template #body="slotProps" >
                <InputNumber  name="Qty" mode="decimal" :optionalDecimal="true" v-model="slotProps.data.Qty" :max="slotProps.data.max_qty" :autoChangeMax="false" :disabled="slotProps.data.disable_edit_qty || !canEdit(slotProps.data) || true" class="p-inputtext-sm w-10rem" @blur="editDetail(slotProps.data)"  />
            </template>
        </Column>
        <Column field="UOM" :header="$t('uom')">
            <template #body="slotProps">
                {{slotProps.data.UOM}}
            </template>
        </Column>
        <Column field="Delivery_Date" :header="$t('delivery_date')">
            <template #body="slotProps">
                <DatePicker v-model="slotProps.data.Delivery_Date" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-inputtext-sm w-10rem" v-if="stomodel" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />    
            </template>
        </Column>
        <!-- <Column field="Plant_Supplying" :header="$t('plant_supplying') + '*'"> -->
        <Column field="Plant_Supplying">
            <template #header>
                {{ $t('plant_supplying') }}
                <span style="color:red">*</span>
            </template>
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-20rem" v-model="slotProps.data.Plant_Supplying" :filter="true" :url="this.$API_URL + 'list/plant'" :minLength="0" :params="{ }" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <!-- <Column field="Plant_Receiving" :header="$t('plant_receiving') + '*'"> -->
        <Column field="Plant_Receiving">
            <template #header>
                {{ $t('plant_receiving') }}
                <span style="color:red">*</span>
            </template>
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-20rem" v-model="slotProps.data.Plant_Receiving" :filter="true" :url="this.$API_URL + 'list/plant'" :minLength="0" :params="{ }" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Tolerance_Over" :header="$t('tolerance_over')" >
            <template #body="slotProps">
                <InputNumber class="p-inputtext-sm w-5rem" v-model="slotProps.data.Tolerance_Over" mode="decimal" :optionalDecimal="true" :disabled="!canEdit(slotProps.data)" @blur="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Tolerance_Under" :header="$t('tolerance_under')" >
            <template #body="slotProps">
                <InputNumber class="p-inputtext-sm w-5rem" v-model="slotProps.data.Tolerance_Under" mode="decimal" :optionalDecimal="true" :disabled="!canEdit(slotProps.data)" @blur="editDetail(slotProps.data)"  />
            </template>
        </Column>
        <!-- <Column field="Tolerance_Expeditor" :header="$t('tolerance_expeditor')" >
            <template #body="slotProps">
                <InputNumber class="p-inputtext-sm w-5rem" v-model="slotProps.data.Tolerance_Expeditor" mode="decimal" :optionalDecimal="true" :disabled="!canEdit" />
            </template>
        </Column> -->
        <Column field="Transport_Type" :header="$t('transport_type')">
            <template #body="slotProps">
                <InputText class="p-inputtext-sm w-5rem" name="Transport_Type" type="text" disabled v-model="slotProps.data.Transport_Type" @change="editDetail(slotProps.data)"  />
            </template>
        </Column>
        <Column field="Transaction_Type" :header="$t('transaction_type')" headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-10rem" v-model="slotProps.data.Transaction_Type" :filter="true" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.STO_TRANSACTION_TYPE }" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Tracking_No" :header="$t('tracking_no')">
            <template #body="slotProps">
                <InputText class="p-inputtext-sm w-10rem" name="Tracking_No" type="text" v-model="slotProps.data.Tracking_No" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="PO_SO_Contract_Item_No" :header="$t('po_so_contract_item_no')">
            <template #body="slotProps">
                <InputText class="p-inputtext-sm w-10rem" name="Ref_No" type="text" v-model="slotProps.data.PO_SO_Contract_Item_No" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Mat_Doc_Year" :header="$t('mat_doc_year')">
            <template #body="slotProps">
                <InputText class="p-inputtext-sm w-5rem" name="Mat_Doc_Year" type="text" v-model="slotProps.data.Mat_Doc_Year" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="ZGRDaily" :header="$t('zgrdaily')">
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-5rem" v-model="slotProps.data.ZGRDaily" :filter="true" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.ZGRDAILY_DATA }" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Continuous" :header="$t('continuous')">
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-5rem" v-model="slotProps.data.Continuous" :filter="true" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.CONTINUOUS }" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Trip_Type" :header="$t('trip_type')">
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-10rem" v-model="slotProps.data.Trip_Type" :filter="true" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.FREIGHT_TRIP_TYPE }" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Truck_Type" :header="$t('truck_type')">
            <template #body="slotProps">
                <InputText class="p-inputtext-sm w-10rem" name="Truck_Type" type="text" v-model="slotProps.data.Truck_Type" disabled @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Load_Port" :header="$t('loading')">
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-20rem" v-model="slotProps.data.Load_Port" :filter="true" :url="this.$API_URL + 'list/location_code'" :minLength="0" :params="{ }" disabled/>
                <!-- <InputText class="p-inputtext-sm w-15rem" name="Load_Port" type="text" v-model="slotProps.data.loading_name" disabled @change="editDetail(slotProps.data)" /> -->
            </template>
        </Column>
        <Column field="Dest_Port" :header="$t('destination')">
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-20rem" v-model="slotProps.data.Dest_Port" :filter="true" :url="this.$API_URL + 'list/location_code'" :minLength="0" :params="{ }" disabled/>
                <!-- <InputText class="p-inputtext-sm w-15rem" name="Dest_Port" type="text" v-model="slotProps.data.dest_port_name" disabled @change="editDetail(slotProps.data)" /> -->
            </template>
        </Column>
        <Column field="Route_No" :header="$t('route_no')">
            <template #body="slotProps">
                <InputText class="p-inputtext-sm w-10rem" name="Truck_Type" type="text" v-model="slotProps.data.Route_No" disabled @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Discharge_Port" :header="$t('discharge_port')" headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-10rem" v-model="slotProps.data.Discharge_Port" :filter="true" :url="this.$API_URL + 'list/discharge_port'" :minLength="0" :params="{ }" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="FRC_Term" :header="$t('frc_term')" headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-10rem" v-model="slotProps.data.FRC_Term" :filter="true" :url="this.$API_URL + 'list/frc_term'" :minLength="0" :params="{ }" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Quantity_Term" :header="$t('quantity_term')">
            <template #body="slotProps">
                 <CustomSelect class="p-inputtext-sm w-10rem" v-model="slotProps.data.Quantity_Term" :filter="true" :url="this.$API_URL + 'list/quantity_term'" :minLength="0" :params="{ }" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Valuation_Type" :header="$t('valuation_type')">
            <template #body="slotProps">
                <InputText class="p-inputtext-sm w-10rem" name="Valuation_Type" type="text" v-model="slotProps.data.Valuation_Type" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="KB" :header="$t('kb')" headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-10rem" v-model="slotProps.data.KB" :filter="true" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.KB }" @change="editDetail(slotProps.data)" :disabled="!canEdit(slotProps.data)" />
            </template>
        </Column>
        <Column field="Facility" :header="$t('facility')" headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
            <template #body="slotProps">
                <CustomSelect class="p-inputtext-sm w-10rem" v-model="slotProps.data.Facility" :filter="true" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.FACILITY }" @change="editDetail(slotProps.data)" :disabled="!canEdit(slotProps.data)" />
            </template>
        </Column>
        <Column field="Previous_STO" :header="$t('previous_sto')">
            <template #body="slotProps">
                <InputText  class="p-inputtext-sm w-10rem" name="Previous_STO" type="text" v-model="slotProps.data.Previous_STO" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Previous_STO_Item_No" :header="$t('item_no')">
            <template #body="slotProps">
                <InputText class="p-inputtext-sm w-5rem" name="Previous_STO_Item_No" type="text" v-model="slotProps.data.Previous_STO_Item_No" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
         <Column field="IPB_No" :header="$t('ipb_no')">
            <template #body="slotProps">
                <InputText  class="p-inputtext-sm w-10rem" name="IPB_No" type="text" v-model="slotProps.data.IPB_No" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="IPB_Item_No" :header="$t('item_no')">
            <template #body="slotProps">
                <InputText class="p-inputtext-sm w-5rem" name="IPB_Item_No" type="text" v-model="slotProps.data.IPB_Item_No" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <Column field="Freight_Approval_Reason" :header="$t('freight_approval_reason')">
            <template #body="slotProps">
                <InputText class="p-inputtext-sm w-15rem" name="IPB_Item_No" type="text" v-model="slotProps.data.Freight_Approval_Reason" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
            </template>
        </Column>
        <template #expansion="slotProps">
            <div class="grid ml-1">
                <div class="col-3">
                    <FormField :labelName="$t('item_text')" fieldName="Tolerance" v-model="slotProps.data" fieldClass="col-6" labelClass="col-4" >
                        <Textarea :autoResize="true" rows="3"  v-model="slotProps.data.Item_Text" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
                    </FormField>
                    
                    <FormField :labelName="$t('material_po_text')" fieldName="Material_PO_Text" v-model="slotProps.data" fieldClass="col-6" labelClass="col-4" >
                        <Textarea :autoResize="true" rows="3"  v-model="slotProps.data.Material_PO_Text" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
                    </FormField>

                    <FormField :labelName="$t('delivery_text')" fieldName="Tolerance" v-model="slotProps.data" fieldClass="col-6" labelClass="col-4" >
                        <Textarea :autoResize="true" rows="3"  v-model="slotProps.data.Delivery_Text" :disabled="!canEdit(slotProps.data)" @change="editDetail(slotProps.data)" />
                    </FormField>
                </div>
                <div class="col-6">
                    <DataTable :value="slotProps.data.Conditions" style="position:sticky!important" responsiveLayout="scroll" :rowClass="hideRow">
                        <Column :exportable="false">
                            <template #header="">
                                <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetailCondition(slotProps.data)" :disabled="!canEdit(slotProps.data)"/>
                            </template>
                            <template #body="slotProps1">
                                <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetailCondition(slotProps.data, slotProps1.index)" :disabled="slotProps1.data.Condition_Category == $CONDITION_CATEGORY.FREIGHT || !canEdit(slotProps1.data)" @change="editDetailCondition(slotProps1.data)" />
                            </template>
                        </Column>
                        <Column field="Condition_Type" :header="$t('condition_type')"> 
                            <template #body="slotProps1">
                                <CustomSelect class="p-inputtext-sm" v-model="slotProps1.data.Condition_Type" :filter="true" :url="this.$API_URL + 'list/condition_type'" :minLength="0" :params="{ category: slotProps1.data.Condition_Category, per_value: slotProps1.data.Condition_Category == $CONDITION_CATEGORY.FREIGHT ? stomodel.Per_Value : '' }" :disabled="!canEdit(slotProps1.data)" @change="editDetailCondition(slotProps1.data)"/>
                            </template>
                        </Column>
                        <Column field="Amount" :header="$t('amount')">
                            <template #body="slotProps1" >
                                <InputNumber  name="Amount" mode="decimal" :optionalDecimal="true" v-model="slotProps1.data.Amount" :disabled="slotProps1.data.Condition_Category == $CONDITION_CATEGORY.FREIGHT || !canEdit(slotProps1.data)" @blur="editDetailCondition(slotProps1.data)"/>
                            </template>
                        </Column>
                        <Column field="Ccy" :header="$t('ccy')">
                            <template #body="slotProps1">
                                <InputText name="Ccy" type="text" disabled v-model="slotProps1.data.Ccy" />
                            </template>
                        </Column>
                        <Column field="Per" :header="$t('per')">
                            <template #body="slotProps1">
                                <InputText name="Per" type="text" v-model="slotProps1.data.Per" :disabled="slotProps1.data.Condition_Category == $CONDITION_CATEGORY.FREIGHT || !canEdit(slotProps1.data)" @change="editDetailCondition(slotProps1.data)"/>
                            </template>
                        </Column>
                        <Column field="UOM" :header="$t('uom')">
                            <template #body="slotProps1">
                                <InputText name="UOM" type="text" v-model="slotProps1.data.UOM" :disabled="slotProps1.data.Condition_Category == $CONDITION_CATEGORY.FREIGHT || !canEdit(slotProps1.data)" @change="editDetailCondition(slotProps1.data)"/>
                            </template>
                        </Column>
                        <Column field="Transporter_Code" :header="$t('transporter')">
                            <template #body="slotProps1">
                                <InputText name="Transporter_Code" type="text" disabled v-model="slotProps1.data.Transporter_Code" />
                                <!-- <CustomSelect class="p-inputtext-sm" v-model="slotProps1.data.Transporter_Code" :filter="true" :url="this.$API_URL + 'list/transporter_all'" :minLength="0" :params="{ }" /> -->
                            </template>
                        </Column>
                        <Column field="Conversion_Numerator" :header="$t('numerator')">
                            <template #body="slotProps1">
                                <InputText name="Conversion_Numerator" type="text" disabled v-model="slotProps1.data.Conversion_Numerator" />
                                <!-- <CustomSelect class="p-inputtext-sm" v-model="slotProps1.data.Transporter_Code" :filter="true" :url="this.$API_URL + 'list/transporter_all'" :minLength="0" :params="{ }" /> -->
                            </template>
                        </Column>
                        <Column field="Conversion_Denominator" :header="$t('denominator')">
                            <template #body="slotProps1">
                                <InputText name="Conversion_Denominator" type="text" disabled v-model="slotProps1.data.Conversion_Denominator" />
                                <!-- <CustomSelect class="p-inputtext-sm" v-model="slotProps1.data.Transporter_Code" :filter="true" :url="this.$API_URL + 'list/transporter_all'" :minLength="0" :params="{ }" /> -->
                            </template>
                        </Column>
                        <Column field="Conversion_UOM" :header="$t('conversion_uom')">
                            <template #body="slotProps1">
                                <InputText name="Conversion_UOM" type="text" disabled v-model="slotProps1.data.Conversion_UOM" />
                                <!-- <CustomSelect class="p-inputtext-sm" v-model="slotProps1.data.Transporter_Code" :filter="true" :url="this.$API_URL + 'list/transporter_all'" :minLength="0" :params="{ }" /> -->
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </template>
    </DataTable>

    <Dialog header="Confirmation" v-model:visible="showWithoutPriceConfirmation" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width:'50vw'}" :modal="true" :closable="false">
        <p>
            {{$t('message.sto_change_without_price')}}
        </p>
        <template #footer>
            <Button :label="$t('no')" icon="pi pi-times" @click="onChangeWithoutPrice(false)" class="p-button-danger"></Button>
            <Button :label="$t('yes')" icon="pi pi-check" @click="onChangeWithoutPrice(true)" class="p-button-sucess"></Button> 
        </template>
    </Dialog>
</template>

<script>
    export default{
        name: "_STO",
        emits:['close', 'block-ui', 'unblock-ui', 'change-model'],
        props:{
            stomodel: {
                type: Object,
                default: null
            },
            mode:{
                type:String,
                default:""
            },
            conditionmodel:{
                type: Object,
                default: null
            },
            defaultconditionmodel:{
                type:Object,
                default:null
            },
            defaultdetailmodel:{
                type:Object,
                default:null
            }
        },
        data(){
            return {
                url: this.$API_URL + "sto/",
                expandedRows: [],
                showWithoutPriceConfirmation: false,
            }
        },
        methods:{
            hideRow(data) {
                return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : '';
            },
            deleteRow(data) {
                var setDelete = false;

                if(data.mode == this.$FORM_MODE_DELETE)
                    setDelete = true;
                if(data.Is_Deleted)
                    setDelete = true;

                return setDelete ? 'row-delete' : '';
            },
            onChangePIC(event){
                if(event && this.stomodel){
                    this.stomodel.PIC_Location = event.location;
                }
            },
            onChangeCcy(event){
                if(event && this.stomodel){
                    if(this.stomodel.Conditions.length > 0){
                        for(var i=0; i< this.stomodel.Conditions.length;i++){
                            this.stomodel.Conditions[i].Ccy = event.id;
                        }
                    }

                    if(this.stomodel.Details.length > 0){
                        for(var i=0; i< this.stomodel.Details.length;i++){
                            var detail = this.stomdel.Details[i];

                            detail.Ccy = event.id;

                            if(detail.Conditions.length > 0){
                                for(var x = 0; x < detail.Conditions.length; x++){
                                    detail.Conditions[x].Ccy = event.id;
                                }
                            }
                        }
                    }
                }
            },
            onClickWithoutPrice(event){
                // if(event && this.stomodel){
                //     this.stomodel.Conditions = [];

                //     if(event == "Y"){
                //         for(var i=0; i< this.defaultconditionmodel.length;i++){
                //             var newCondition = { ...this.defaultconditionmodel[i] };
                //             this.stomodel.Conditions.push(newCondition);
                //         }
                //     }
                // }
                
                var withoutPrice = this.stomodel.Without_Price;
                this.stomodel.Without_Price = withoutPrice == "Y" ? "N" : "Y";
                this.showWithoutPriceConfirmation = true;
            },
            onChangeWithoutPrice(canContinue){
                this.showWithoutPriceConfirmation = false;
                var self = this;

                if(canContinue){
                    var withoutPrice = this.stomodel.Without_Price;
                    var perValue = this.stomodel.Per_Value == "Y" ? true : false;
                    console.log(withoutPrice);
                    this.stomodel.Without_Price = withoutPrice == "Y" ? "N" : "Y";


                    if(this.stomodel.Without_Price == "N"){
                        // if(perValue){
                        //     this.stomodel.Conditions = [];
                        //     for(var i=0; i< this.defaultconditionmodel.length;i++){
                        //         var newCondition = { ...this.defaultconditionmodel[i] };
                        //         this.stomodel.Conditions.push(newCondition);
                        //     }
                        // }
                        // else{
                        //     for(var i=0; i< this.defaultdetailmodel.length;i++){
                        //         var newDetail = { ...this.defaultdetailmodel[i]};
                        //         this.stomodel.Details[i].Conditions = [];
                        //         for(var x = 0; x< newDetail.Conditions.Length;x++){
                        //             var newCondition = {...newDetail.Conditions[x]};
                        //             this.stomodel.Details[i].Conditions.push(newCondition);
                        //         }
                        //     }
                        // }

                        for(var i=0; i< self.defaultdetailmodel.length;i++){

                            console.log(self.defaultdetailmodel);
                                var newDetail = { ...self.defaultdetailmodel[i]};
                                self.stomodel.Details[i].Conditions = [];
                                for(var x = 0; x< newDetail.Conditions.length;x++){
                                    var newCondition = {...newDetail.Conditions[x]};
                                    self.stomodel.Details[i].Conditions.push(newCondition);
                                }
                        }
                    }
                    else{
                        // if(perValue){
                        //     this.stomodel.Conditions = [];
                        // }
                        // else{
                        //     for(var i=0; i< this.stomodel.Details.length;i++){
                        //         this.stomodel.Details[i].Conditions = [];
                        //     }
                        // }
                        for(var i=0; i< this.stomodel.Details.length;i++){
                                this.stomodel.Details[i].Conditions = [];
                        }
                    }


                }
            },
            addCondition() {
                var newDetail = this.conditionmodel;
                newDetail.mode = this.$FORM_MODE_CREATE;
                var det = { ...newDetail };

                this.stomodel.Conditions.push(det);
            },
            deleteCondition(event) {
                if (event) {
                    var detail = this.stomodel.Conditions[event.index];

                    if (detail.mode == this.$FORM_MODE_CREATE) this.stomodel.Conditions.splice(this.stomodel.Conditions.indexOf(detail), 1);
                    else detail.mode = this.$FORM_MODE_DELETE;
                }
            },
            editCondition(index) {
                if (this.stomodel.Conditions && this.stomodel.Conditions.Length > 0) {
                    let m = this.stomodel.Conditions[index].mode;

                    if (m == this.$FORM_MODE_UNCHANGED) {
                        this.stomodel.Conditions[index].mode = this.$FORM_MODE_EDIT;
                    }
                }
            },
            onRowExpand(event){
                this.expandedRows.push(event.data);
            },
            onRowCollapse(event){
                this.expandedRows.splice(this.expandedRows.indexOf(event.data), 1);
            },
            copyDetail(event){
                if(event){
                    if(event.index != this.stomodel.Details.length - 1){
                        var from = this.stomodel.Details[event.index];
                        for(var i = (event.index + 1); i < this.stomodel.Details.length;i++){
                            var to = this.stomodel.Details[i];

                            to.Delivery_Date = from.Delivery_Date;
                            to.Plant_Supplying = from.Plant_Supplying;
                            to.Plant_Receiving = from.Plant_Receiving;
                            to.Tolerance_Over = from.Tolerance_Over;
                            to.Tolerance_Under = from.Tolerance_Under;
                            to.Tolerance_Expeditor = from.Tolerance_Expeditor;
                            to.Transaction_Type = from.Transaction_Type;
                            //to.Tracking_No = from.Tracking_No;
                            to.Ref_No = from.Ref_No;
                            to.Mat_Doc_Year = from.Mat_Doc_Year;
                            to.ZGRDaily = from.ZGRDaily;
                            to.Continuous = from.Continuous;
                            to.Discharge_Port = from.Discharge_Port;
                            to.FRC_Term = from.FRC_Term;
                            to.Quantity_Term = from.Quantity_Term;
                            to.Valuation_Type = from.Valuation_Type;
                            to.Previous_STO = from.Previous_STO;
                            to.Previous_STO_Item_No = from.Previous_STO_Item_No;
                            to.IPB_No = from.IPB_No;
                            to.IPB_Item_No = from.IPB_Item_No;

                            to.Item_Text = from.Item_Text;
                            to.Material_PO_Text = from.Material_PO_Text;
                            to.Delivery_Text = from.Delivery_Text;
                        }
                    }
                }
            },
            addDetailCondition(detail) {
                var newDetail = this.conditionmodel;
                newDetail.mode = this.$FORM_MODE_CREATE;
                var det = { ...newDetail };

                detail.Conditions.push(det);
            },
            deleteDetailCondition(detail, index) 
            {
                let con = detail.Conditions[index];

                if (con.mode == this.$FORM_MODE_CREATE) detail.Conditions.splice(detail.Conditions.indexOf(con), 1);
                else con.mode = this.$FORM_MODE_DELETE;
            },
             editDetailCondition(data) {
                let m = data.mode;

                if(m == this.$FORM_MODE_UNCHANGED){
                    data.mode = this.$FORM_MODE_EDIT;
                }
            },
            editDetail(data){
                let m = data.mode;

                if(m == this.$FORM_MODE_UNCHANGED){
                    data.mode = this.$FORM_MODE_EDIT;
                }
            },
            simulateDeleteItem(){
                var self = this;

                this.$emit("block-ui");

                this.$axios.post(this.url + "simulate_delete", self.stomodel)
                    .then((response) => {
                        if (response.data.success) {
                            //this.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                            //self.checkedSPR = true;
                            self.$emit('change-model', response.data.data);
                            self.$emit("unblock-ui");
                        }
                        else {
                            //self.checkSPRMessage = response.data.message;
                            self.$emit("unblock-ui");
                            //self.showError('Error Filtering Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Simulate Delete Data', error);
                        self.$emit("unblock-ui");
                    });
            },
            onChangeToleranceExpeditor(event){
                var self =this;
                if(this.stomodel){
                    if(self.stomodel.Details.length > 0){
                        for(var i = 0; i < self.stomodel.Details.length; i++){
                            var detail = self.stomodel.Details[i];

                            detail.Tolerance_Over = event.value;
                            detail.Tolerance_Under = event.value;
                        }
                    }
                }
            },
            showError(summary, message) {
                this.$emit('unblock-ui');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: null});
            },
            canEdit(data){
                var canEdit = false;
                if(this.mode == this.$FORM_MODE_VIEW){
                    canEdit = false;
                }
                else{
                    var canEdit = this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;

                    if(data != null){
                        canEdit = !data.Is_Deleted;
                    }
                }

                return canEdit;
            },
            
        },
        created(){

        },
        computed:{
            isCreate(){
                return this.mode == this.$FORM_MODE_CREATE;
            },
           
            canSave(){
                return this.mode != this.$FORM_MODE_VIEW;
            },
            canInputFBA(){
                if(this.stomodel){
                    return this.stomodel.can_input_fba;
                }
                else{
                    return false;
                }
            },
            mustWithoutPrice(){
                if(this.stomodel){
                    return this.stomodel.must_without_price;
                }
                else{
                    return false;
                }
            },
            canEditHeader(){
                var canEdit = this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
                return canEdit;
            },
            isWaiting(){
                if(this.stomodel){
                    if(this.stomodel.Document_No){
                        return false;
                    }
                }

                return true;
            }
        }
    }


</script>